import { useEffect, useState } from 'react';
import { apiService } from '../../services/api';

// Pastille « nouveautés » du lien Accueil : GET /home/news donne les clés de ce qui est sur l'accueil (mot du jour,
// mails, propositions de la tactique, kickoffs). Sur l'accueil, elles sont notées comme vues ; ailleurs, une clé
// jamais vue allume la pastille.

const SEEN_KEY = 'deepflow.home.seenNews';
const POLL_MS = 2 * 60000;
const MAX_KEPT = 400;

const readSeen = () => {
  try {
    return new Set(JSON.parse(localStorage.getItem(SEEN_KEY) || '[]'));
  } catch (err) {
    return new Set();
  }
};

export const hasUnseen = (keys, seen) => (keys || []).some((key) => !seen.has(key));

const markSeen = (keys) => {
  const kept = [...new Set([...keys, ...readSeen()])].slice(0, MAX_KEPT); // les clés du moment d'abord
  try {
    localStorage.setItem(SEEN_KEY, JSON.stringify(kept));
  } catch (err) {
    // stockage indisponible : la pastille se rallumera à la prochaine visite
  }
};

const useHomeNews = (enabled, onHome) => {
  const [fresh, setFresh] = useState(false);
  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    const check = async () => {
      if (document.visibilityState !== 'visible') return;
      try {
        const { keys = [] } = await apiService.get('/home/news');
        if (!active) return;
        if (onHome) markSeen(keys);
        setFresh(!onHome && hasUnseen(keys, readSeen()));
      } catch (err) {
        if (active) setFresh(false);
      }
    };
    check();
    const timer = setInterval(check, POLL_MS);
    document.addEventListener('visibilitychange', check);
    return () => {
      active = false;
      clearInterval(timer);
      document.removeEventListener('visibilitychange', check);
    };
  }, [enabled, onHome]);
  return fresh;
};

export default useHomeNews;
